import React from "react";
import Select from "react-select";

const RYStepTwo = ({
  formData,
  handleChange,
  handleTextDateChange,
  occupationOptions,
}) => {
  const convertDateToDDMMYYYY = (inputDate) => {
    if (!inputDate) return "";
    const [year, month, day] = inputDate.split("-");
    return `${day}-${month}-${year}`;
  };

  return (
    <section>
      <div className="row">
        <div className="col-lg-6 mb-2">
          <label className="text-label">
            Gender <span style={{ color: "red" }}>*</span>
          </label>
          <select
            name="gender"
            className="form-control"
            value={formData.gender}
            onChange={handleChange}
            required
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
        </div>

        <div className="col-lg-6 mb-2">
          <label className="text-label">
            Date of Birth <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="date"
            name="date_of_birth"
            className="form-control"
            value={convertDateToDDMMYYYY(formData.date_of_birth)}
            onChange={handleTextDateChange}
            required
          />
        </div>

        <div className="col-lg-6 mb-2">
          <label className="text-label">
            Height (cm)<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            name="height"
            className="form-control"
            value={formData.height}
            onChange={handleChange}
            placeholder="Enter Height"
          />
        </div>

        <div className="col-lg-6 mb-2">
          <label className="text-label">
            Weight (kg)<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            name="weight"
            className="form-control"
            value={formData.weight}
            onChange={handleChange}
            placeholder="Enter Weight"
          />
        </div>

        <div className="col-lg-6 mb-2">
          <label className="text-label">
            Occupation<span style={{ color: "red" }}>*</span>
          </label>
          <Select
            name="occupation"
            options={occupationOptions}
            value={
              formData.occupation
                ? occupationOptions.find(
                    (opt) => opt.value === formData.occupation
                  )
                : null
            }
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  name: "occupation",
                  value: selectedOption ? selectedOption.value : "",
                },
              })
            }
            isSearchable
            placeholder="Select Occupation"
            styles={{
              control: (provided) => ({
                ...provided,
                minHeight: "50px",
                height: "50px",
              }),
              singleValue: (provided) => ({
                ...provided,
                lineHeight: "50px",
              }),
              dropdownIndicator: (provided) => ({
                ...provided,
                padding: "4px",
              }),
              indicatorSeparator: (provided) => ({
                ...provided,
                display: "none",
              }),
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default RYStepTwo;
